"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Was erwartet mich in der ersten Sitzung?",
  answer: "In unserer ersten Begegnung nehmen wir uns Zeit, um dein Anliegen in Ruhe zu besprechen. Ich kläre deine Bedürfnisse und Ziele und ich stelle dir meine Arbeitsweise vor. Es geht vor allem darum, einen sicheren Raum zu schaffen, in dem du dich wohl und verstanden fühlst."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="häufige-fragen" className="bg-gradient-to-b from-secondary/30 to-background py-24 md:py-32">
      <div ref={ref} className={`container mx-auto px-4 max-w-[800px] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16">
          
          
        </div>

        <Accordion type="single" collapsible className="w-full mb-12">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/60 py-2">
              
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pt-2 pb-6 font-sans">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="text-center mt-16 pt-8 border-t border-border/40">
          <p className="text-foreground font-medium mb-6 font-sans">Hast du weitere Fragen zu meiner Arbeit bei Wandelherz?</p>
          <Button asChild variant="outline" size="lg" className="rounded-full px-8">
            <Link to="/ContactPage">Kontakt aufnehmen</Link>
          </Button>
        </div>
      </div>
    </section>;
}